export default __webpack_public_path__ + "static/media/cat.f331392e.svg";